import React, { useState } from 'react';

import { ComboBox, Button } from '@components';
import { useNavigate } from 'react-router-dom';
import { TRANSPARENCIA } from '../../../utils/paths';

const links = [
  {
    label: 'Atas do Conselho Deliberativo',
    to: 'atasConselhoDeliberativo',
  },
  {
    label: 'Atas do Conselho Fiscal',
    to: 'atasConselhoFiscal',
  },
  {
    label: 'Alterações Regulamentares',
    to: 'alteracoesRegulamentares',
  },
  {
    label: 'Alterações Estatuárias',
    to: 'alteracoesEstatuarias',
  },
  {
    label: 'Participações em Assembleias',
    to: 'participacoesAssembleias',
  },
  {
    label: 'Fornecedores',
    to: 'fornecedores',
  },
];

export const TransparenciaCard = () => {
  const [tipoTransparencia, setTipoTransparencia] = useState('');
  const navigate = useNavigate();

  return (
    <div className="card">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-32">Transparência</h1>

        <ComboBox
          label="Escolha o tópico"
          options={links.map((x) => {
            return { value: x.to, label: x.label };
          })}
          defaultValue={tipoTransparencia}
          onChange={setTipoTransparencia}
        />

        <Button
          disabled={tipoTransparencia === ''}
          className="mt-32"
          onClick={() => {
            navigate(`${TRANSPARENCIA}/${tipoTransparencia}`);
          }}
        >
          Prosseguir
        </Button>
      </div>
    </div>
  );
};
